import React, { useState } from "react";
import DisplayMedia from "../components/PostManager/DisplayMedia";
import { SaveToPlatformPanel, VideoForPlatform } from "../features/video-management";
import { useAuth } from "../context/AuthContext";
import { useCustomerWorkspace } from "../context/CustomerWorkspaceContext";

/**
 * Standalone page for browsing and uploading customer media (images/videos).
 */
const MediaLibraryPage: React.FC = () => {
  const { idToken: rawIdToken } = useAuth();
  const idToken = rawIdToken || "";
  const { selectedCustomerId: libraryCustomerId, selectedCustomerName } = useCustomerWorkspace();
  const [showSaveToPlatform, setShowSaveToPlatform] = useState(false);
  const [videoForPlatform, setVideoForPlatform] =
    useState<VideoForPlatform | null>(null);

  return (
    <div className="p-6">
      <div className="mx-auto max-w-[1130px] space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-theme-fg">Media Library</h1>
          {selectedCustomerName && (
            <div className="mt-2 inline-flex items-center gap-2 rounded-full bg-green-50 px-3 py-1.5 text-sm font-medium text-green-700 shadow-sm ring-1 ring-inset ring-green-600/20 transition-all hover:bg-green-100 dark:bg-green-900/20 dark:text-green-400 dark:ring-green-500/20 dark:hover:bg-green-900/40">
              <span className="material-icons-outlined text-[18px] text-amber-600 opacity-90 dark:text-amber-500">
                storefront
              </span>
              <span>{selectedCustomerName}</span>
            </div>
          )}
        </div>
        <div className="rounded-md border border-theme-border bg-theme-surface p-6 shadow-sm">
          <DisplayMedia
            showToolbarUpload
            onPrepareForSocial={(videoUrl, thumbnailUrl) => {
              setVideoForPlatform({
                videoUrl,
                thumbnailUrl,
                sourceType: "upload",
              });
              setShowSaveToPlatform(true);
            }}
          />
        </div>
      </div>

      {showSaveToPlatform && videoForPlatform && idToken && (
        <SaveToPlatformPanel
          isOpen={showSaveToPlatform}
          onClose={() => {
            setShowSaveToPlatform(false);
            setVideoForPlatform(null);
          }}
          video={videoForPlatform}
          customerId={libraryCustomerId ?? ""}
          idToken={idToken}
          agentId=""
        />
      )}
    </div>
  );
};

export default MediaLibraryPage;
